
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import EventModal from './EventModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { Card } from 'react-bootstrap';
import { FaFilter } from "react-icons/fa";

const EmployeeEvent = ({ }) => {
    const [events, setEvent] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedeventId, setSelectedeventId] = useState(null);
    const [selectedeventData, setSelectedeventData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [countries, setCountries] = useState([]);
    const [errors, setErrors] = useState({});
    const [industries, setIndustries] = useState([]);
    const WithCreatePermission = withPermission(({ children }) => children, ['event-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['event-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['event-delete']);
    const didFetchRef = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [showSlideModal, setShowSlideModal] = useState(false);
    const didInitialFetch = useRef(false);
    const [sectorFilter, setSectorFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    useEffect(() => {

        // fetchevent(); // fetch initial page
        // fetchIndustries();
    }, []);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchevent(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]); // Add typeFilter and sectorFilter to the dependency array
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    const fetchevent = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let params = { page };

            const response = await axios.get(`${backendUrl}/api/events`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
            });

            // pagination object
            const pagination = response.data?.data;

            // events array
            setEvent(pagination?.data || []);
            setCurrentPage(pagination?.current_page || 1);
            setPageCount(pagination?.last_page || 1);

        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            let allIndustries = [];
            let currentPage = 1;
            let lastPage = 1;


            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allIndustries = [...allIndustries, ...response.data.industry]


            setIndustries(allIndustries);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };

    const addevent = async (newevent) => {
        try {
            const formData = new FormData();
            // Append regular fields
            Object.keys(newevent).forEach((key) => {
                formData.append(key, newevent[key]);
            });


            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/events`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const createdevent = response.data.data;

            if (createdevent) {
                setEvent((prevevent) => [...prevevent, createdevent]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding event`, error);
            }
        }
    };


    const editevent = async (contactId, updatedData) => {
        try {

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for editing
            const response = await axios.put(`${backendUrl}/api/events/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const updatedevent = response.data.data;

            if (updatedevent) {
                setEvent((prevevent) =>
                    prevevent.map((contact) => (contact.id === updatedevent.id ? updatedevent : contact))
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else
                console.error(`Error updating`, error);
        }
    };

    const deleteevent = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');

                    const token = userInfo?.token;

                    // Corrected API endpoint with dynamic contact_type for deleting
                    await axios.delete(`${backendUrl}/api/events/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setEvent(events.filter((contact) => contact.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The event has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting event:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete event. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (contactId = null) => {
        if (contactId) {
            const contactToEdit = events.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedeventData(contactToEdit);
            }
        } else {
            setSelectedeventData(null);
        }
        setSelectedeventId(contactId);
        // setShowModal(true);
        setShowSlideModal(true);

    };
    const handleShowSlideModal = () => {
        setSelectedeventData(null);
        setSelectedeventId(null);
        setShowSlideModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setShowSlideModal(false);

        setSelectedeventId(null);
        setSelectedeventData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchevent(selectedPage);
    };
    const getIndustryNameById = (industryId) => {
        const industry = industries.find(industry => industry.id == industryId);
        return industry ? industry.name : '';
    };
    const formatOrgType = (type) => {
        if (!type) return ''; // Return empty string if type is null or undefined
        return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase().replace(/_/g, ' ');
    };

    const [viewType, setViewType] = useState('list');
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'sector') setSectorFilter(value);
        if (filterType === 'type') setTypeFilter(value);

        setFilterDropdown(null); // Close dropdown after selection
    };




    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">
                                    events
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            {viewType === 'list' ? (
                                <div className="card">
                                    <div className="card-body">
                                        {/* <div className="d-flex justify-content-end mb-3"> */}
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className="d-flex">
                                                <div className="search-box me-2 mb-2 d-inline-block">
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search..."
                                                            value={searchQuery}
                                                            onChange={handleSearchChange}
                                                        />
                                                        <i className="bx bx-search-alt search-icon" />
                                                    </div>
                                                </div>



                                            </div>
                                            <div className="d-flex align-items-center">
                                                {/* View Type Icons */}
                                                {/* <div>
                                                    <ul className="nav nav-pills justify-content-end">
                                                        <li className="nav-item">
                                                            <a className="nav-link disabled" href="#" tabIndex={-1} aria-disabled="true"></a>
                                                        </li>
                                                        <li className="nav-item nav-icon" data-bs-placement="top" title="List">
                                                            <a
                                                                className={`nav-link ${viewType === 'list' ? 'bg-primary bg-soft font-size-13' : ''}`}
                                                                href="#"
                                                                onClick={() => setViewType('list')}
                                                            >
                                                                <i className="mdi mdi-format-list-bulleted" />
                                                            </a>
                                                        </li>
                                                        <li className="nav-item nav-icon" data-bs-placement="top" title="Grid">
                                                            <a
                                                                className={`nav-link ${viewType === 'grid' ? 'bg-primary bg-soft' : ''}`}
                                                                href="#"
                                                                onClick={() => setViewType('grid')}
                                                            >
                                                                <i className="mdi mdi-view-grid-outline" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div> */}


                                                {/* <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-rounded waves-effect waves-light mb-3"
                                                onClick={() => handleShowModal()}
                                            >
                                                <i className="mdi mdi-plus me-1"></i> Add event
                                            </button></WithCreatePermission> */}
                                                <WithCreatePermission>
                                                    <button
                                                        type="button"
                                                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                        onClick={handleShowSlideModal}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Add event"
                                                    >
                                                        <i className="mdi mdi-plus"></i>
                                                    </button>
                                                </WithCreatePermission>

                                            </div></div>

                                        <table className="table align-middle table-nowrap table-hover table-check table-list">
                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th className="align-middle">Event</th>
                                                    <th className="align-middle">Start Date</th>
                                                    <th className="align-middle">End Date</th>
                                                    <th className="align-middle">Location</th>
                                                    <th className="align-middle">Description</th>

                                                    <th className="align-middle">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {events.length > 0 ? (
                                                    events.map((client, index) => (
                                                        <tr key={client.id}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`clientCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`clientCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>

                                                            
                                                            <td>{client.title}</td>
                                                            <td>{client.start_date}</td>
                                                            <td>{client.end_date}</td>
                                                            <td>{client.location}</td>
                                                            <td>{client.description}</td>
                                                           


                                                            <td>
                                                                <div className="dropdown font-size-13">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-17"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                        <li>
                                                                            <Link to={`/event/details/${client.id}`} className="dropdown-item">
                                                                                View Details
                                                                            </Link>
                                                                        </li>
                                                                        <li><WithEditPermission>
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => handleShowModal(client.id)}
                                                                            >
                                                                                Edit
                                                                            </button></WithEditPermission>
                                                                        </li>
                                                                        <li><WithDeletePermission>
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => deleteevent(client.id)}
                                                                            >
                                                                                Delete
                                                                            </button></WithDeletePermission>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">No clients found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="row">
                                    <div className='d-flex align-items-center justify-content-end '>
                                        <div>
                                            <ul className="nav nav-pills justify-content-end">
                                                <li className="nav-item">
                                                    <a className="nav-link disabled" href="#" tabIndex={-1} aria-disabled="true"></a>
                                                </li>
                                                <li className="nav-item" data-bs-placement="top" title="List">
                                                    <a
                                                        className={`nav-link ${viewType === 'list' ? 'bg-primary bg-soft' : ''}`}
                                                        href="#"
                                                        onClick={() => setViewType('list')}
                                                    >
                                                        <i className="mdi mdi-format-list-bulleted" />
                                                    </a>
                                                </li>
                                                <li className="nav-item" data-bs-placement="top" title="Grid">
                                                    <a
                                                        className={`nav-link ${viewType === 'grid' ? 'bg-primary bg-soft' : ''}`}
                                                        href="#"
                                                        onClick={() => setViewType('grid')}
                                                    >
                                                        <i className="mdi mdi-view-grid-outline" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>&nbsp;&nbsp;
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    padding: "5px",
                                                    backgroundColor: "rgb(201 227 236)",
                                                    borderColor: "#ccc",
                                                    color: "#333",
                                                }}
                                                onClick={() => handleShowModal()}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                id="tool"
                                                title="Add Deal"
                                            >
                                                <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                            </button></WithCreatePermission>
                                    </div>
                                    {events.length > 0 ? (
                                        events.map((deal, index) => (
                                            <div key={deal.id} className="col-xl-4 col-sm-6">
                                                <Card className='ccard1'>
                                                    <Card.Body>
                                                        <div className="d-flex">
                                                            <div className="flex-shrink-0 me-4">
                                                                <div className="avatar-md">
                                                                    <span className="avatar-title rounded-circle bg-light text-success font-size-16">
                                                                        {deal.name ? deal.name[0].toUpperCase() : 'N'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 overflow-hidden">
                                                                <h5 className="text-truncate font-size-15">
                                                                    <Link to={`/event/details/${deal.id}`} className="dropdown-item text-dark">{deal.name}</Link>
                                                                </h5>
                                                                <p className="text-muted mb-4">{deal.org_type}</p>
                                                                <div className="avatar-group">
                                                                    <div className="avatar-group-item">
                                                                        <p className="text-muted mb-4">{deal.industry?.name}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                    <div className="px-4 py-3 border-top">
                                                        <ul className="list-inline mb-0">

                                                            <li className="list-inline-item me-3">
                                                                <i className="bx bx-calendar me-1" />
                                                                {new Date(deal.created_at).toISOString().split("T")[0]}
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </Card>
                                            </div>

                                        ))
                                    ) : (
                                        <p>No deals found.</p>
                                    )}
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>


            {/* <EventModal
                showModal={showModal}
                handleClose={handleCloseModal}
                orgId={selectedeventId}
                orgData={selectedeventData}
                addOrg={addevent}
                editOrg={editevent}
                orgs={events}
                fetchIndustries={fetchIndustries}
                errors={errors}
                setErrors={setErrors}
                industries={industries}

            // clientIdError={clientIdError}

            /> */}
            <EventModal
                showModal={showSlideModal}
                handleClose={handleCloseModal}
                eventId={selectedeventId}
                eventData={selectedeventData}
                addevent={addevent}
                editevent={editevent}
                events={events}
                errors={errors}
                setErrors={setErrors}
            />
        </div>
    );
};

export default EmployeeEvent;




